import { Ear } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { IntelligenceView } from "./IntelligenceView";

export function IntelligencePage() {
  return (
    <div>
      <PageHeader
        icon={Ear}
        title="Intelligence & Listening"
        description="Monitor social media mentions, track brand sentiment, and stay on top of trending topics relevant to your organisation. Set up keyword alerts to catch coverage the moment it happens."
      />
      <IntelligenceView showHeader={false} />
    </div>
  );
}
